const HomePage = () => {
  return <div>Home</div>;
};

export default HomePage;
